var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAreaBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32812 11.5354L11.4494 13.6567L13.5707 11.5354L12.8637 10.8283L11.9494 11.7425V4.25722L12.8637 5.17148L13.5707 4.46435L11.4494 2.34302L9.32812 4.46435L10.0352 5.17148L10.9494 4.25722V11.7425L10.0352 10.8283L9.32812 11.5354Z",
    fill: "#003DA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 13L3 13.5H8L8.5 13V3L8 2.5H3L2.5 3V13ZM3.5 12.5V3.5H7.5V4.5H5.5V5.5H7.5V6.5H5.5V7.5H7.5V8.5H5V9.5H7.5V10.5H5.5V11.5H7.5V12.5H3.5Z",
    fill: "#003DA6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaBlue);
export default __webpack_public_path__ + "static/media/area-blue.dbadca5706003083ebd377463778a2e5.svg";
export { ForwardRef as ReactComponent };